import { render, staticRenderFns } from "./deleteTeam.vue?vue&type=template&id=4eb58d67&scoped=true&"
import script from "./deleteTeam.vue?vue&type=script&lang=ts&"
export * from "./deleteTeam.vue?vue&type=script&lang=ts&"
import style0 from "./deleteTeam.vue?vue&type=style&index=0&id=4eb58d67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb58d67",
  null
  
)

export default component.exports